import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import SectionContainer from 'components/Containers/SectionContainer';
import UnifiedCCOffersContainer from 'partial/OfferManager/UnifiedCCOffersContainer';
import Disclaimer from 'components/AdvertiserToolTip';
import { SeeAllCards } from 'components/Offers/SeeAllCards/SeeAllCards';

const OffersCards = props => {
  const { credit_offers_header, datatestid } = props ?? {};

  return (
    <SectionContainer className="padb24 bgWhite">
      <Row>
        <Label
          type="H3"
          typeHeader="h2"
          className="borderBottom1 borderNeutral050 padB8 margB16"
        >
          {credit_offers_header}
        </Label>
        <Disclaimer showPartnerText datatestid={datatestid} />
      </Row>
      <FlexContainer className={'flex-column'}>
        <UnifiedCCOffersContainer
          {...props}
          mobileMarginOverride={'m-marglr1'}
          datatestid={null}
          pagePosition={props?.pagePosition}
          showSeeMoreCardsLink={false}
          seeAllCards={
            <SeeAllCards
              link="/offers/creditcard"
              description="See More Credit Cards"
              sizeClass="small"
              onLinkClickCallback={props.onLinkClickCallback}
              key="see-all"
            />
          }
          {...props}
        />
      </FlexContainer>
    </SectionContainer>
  );
};

export default OffersCards;
